import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; 
import Loader from '../../../../components/loader';
import { deleteApiToken, fetchApiTokens, selectApiTokens } from '../apiTokensSlice';
import ApiTokenList from './ApiTokenList';
import { Link } from 'react-router-dom';


const ApiTokensListContainer: React.FC = () => {
  const dispatch = useDispatch<any>();
  const { loading, list, deletingIds } = useSelector(selectApiTokens);

  useEffect(() => { 
    dispatch(fetchApiTokens()); 
  }, [dispatch]);

   const handleDelete = (id: string) => {
      confirmAlert({
          title: 'Confirm API Token',
          message: `Delete this API token? This action cannot be undone.`,
          buttons: [
            {
              label: 'Yes',
              onClick: () => {              
                dispatch(deleteApiToken({ id }));
              }
            },
            {
              label: 'No',
              onClick: () => {}
            }
          ]
        });
    };

     const handleRenew = (id: string) => {
      confirmAlert({
          title: 'Confirm API Token',
          message: `Renew this API token?`,
          buttons: [
            {
              label: 'Yes',
              onClick: () => {              
                dispatch(deleteApiToken({ id }));
              }
            },
            {
              label: 'No',
              onClick: () => {}
            }
          ]
        });
    };
  
  return (
    <div className="container" style={{ padding: 16 }}>
      {(loading) && <Loader />}
      <h2>API Tokens</h2>
      <p>Create and manage API tokens. Keep tokens secret; they act like a password. You can delete a token to revoke it.</p>
      <ApiTokenList tokens={list} deletingIds={deletingIds} onDelete={handleDelete} />
      <div className='buttons mt-3'>
        <Link to={`/user/api-tokens/add`} className="button">Add New Token</Link>
      </div>
    </div>
  );
};

export default ApiTokensListContainer;
